module.exports = __webpack_public_path__ + "static/img/badge-multi-inactive.619e8a8.svg";